import type { ISbStoryData } from 'storyblok'

interface StoryContent {
  _uid: string
}

const MAX_LENGTH = 20

export const useViewedStoriesStore = defineStore('viewed-stories', () => {
  const viewedStories = ref([])

  function viewStory(story: ISbStoryData<StoryContent>) {
    viewedStories.value.push({
      uuid: story?.uuid,
      id: story?.id,
      slug: story?.slug,
      full_slug: story?.full_slug,
      content: {
        _uid: story?.content?._uid,
      },
    })
    if (viewedStories.value.length > MAX_LENGTH) {
      viewedStories.value.shift()
    }
  }

  return {
    viewStory,
    viewedStories,
  }
})
